import React from 'react';

import useNewChapterModal from '@HOOKS/store/modals/useNewChapterModal';
import { useCreateChapter } from '@SERVICES';

import NameInputModal, { FormValues } from '@MODALS/common/NameInputModal';

function NewChapterModal() {
    const {
        state: { data: modalParams },
        actions,
    } = useNewChapterModal();

    const [
        createChapter,
        {
            isLoading, isSuccess, isError, error,
        },
    ] = useCreateChapter();

    const onSave = (formValues: FormValues) => {
        createChapter({
            documentId: modalParams!.documentId,
            name: formValues.name,
        });
    };

    return (
        <NameInputModal
            modalTitle="Create new chapter"
            itemName="Chapter"
            inputPlaceholder="Chapter name"
            successMessage="New chapter has been created!"
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
            onSave={onSave}
            onClose={() => {
                actions.close();
            }}
        />
    );
}

export default NewChapterModal;
